import React, { Component } from "react";
import DashboardHeader from "./DashboardHeader";
import DashboardBody from "./DashboardBody";
import DashboardValuation from "./DashboardValuation";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";
import DashboardQRCode from "./DashboardQRCode";
import CallToActionPhone from "./CallToActionPhone";
import "./print.scss";
import "./editor.scss";

const DEFAULT_DASHBOARD_IRIS_IMG =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/091626_PMA_dashboard-BG-w3_med.jpg";
const TWO_SECTION_DASHBOARD_IRIS_IMG =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/091626_PMA_dashboard-BG_med.jpg";

/** MLS areas that use the 2-section prop-comp layout (city and area). */
const TWO_SECTION_PROP_COMP_AREA_IDS = new Set(["MRN-A2300W"]);

class PropAttributes extends Component {
  render() {
    const {
      agentData,
      MQCityDetails,
      printVersion,
      fromEditor,
      showAllEditButtons,
      currentArea,
      dashboardValuation,
      quarterlyAreaTable,
      quarterlyCityTable,
      hoData,
      priceRangeDashBoardDetailsDTOArea,
      priceRangeDashBoardDetailsDTOCity,
    } = this.props;
    const { mlsAreaID } = currentArea;

    const isAreaDtoEmpty = (() => {
      if (
        !priceRangeDashBoardDetailsDTOArea ||
        (typeof priceRangeDashBoardDetailsDTOArea === "object" &&
          Object.keys(priceRangeDashBoardDetailsDTOArea).length === 0)
      ) {
        return true;
      }
      const areaRanges = priceRangeDashBoardDetailsDTOArea.priceRangeListArea;
      return !Array.isArray(areaRanges) || areaRanges.length === 0;
    })();

    let useCity =
      mlsAreaID === "SMA-353A" || mlsAreaID === "xNPA-E0600C" || isAreaDtoEmpty;

    const useTwoSectionLayout = TWO_SECTION_PROP_COMP_AREA_IDS.has(mlsAreaID);
    const dashboardIrisImg = useTwoSectionLayout
      ? TWO_SECTION_DASHBOARD_IRIS_IMG
      : DEFAULT_DASHBOARD_IRIS_IMG;
    const layoutClassName = `${
      printVersion ? "print-home-value-changed" : "editor-home-value-changed"
    }${fromEditor ? " from-editor" : ""}${
      useTwoSectionLayout ? " two-section-prop-comp" : ""
    }`;

    const showEditButtons = Boolean(fromEditor) && Boolean(showAllEditButtons);

    const priceRangeDashBoardDetailsDTO = useCity
      ? priceRangeDashBoardDetailsDTOCity
      : priceRangeDashBoardDetailsDTOArea;

    const listKey = useCity ? "priceRangeListCity" : "priceRangeListArea";
    const dtoRanges = priceRangeDashBoardDetailsDTO?.[listKey];
    const hasDtoRanges = Array.isArray(dtoRanges) && dtoRanges.length > 0;
    const dashBoardMonths =
      priceRangeDashBoardDetailsDTO?.dashBoardPriceRangeMonths ||
      (useCity
        ? quarterlyCityTable?.dashBoardMonths
        : quarterlyAreaTable?.dashBoardMonths);

    const canShowAreaBody =
      hasDtoRanges ||
      (quarterlyAreaTable && quarterlyAreaTable.dashBoardDetailsWithPriceRange);
    const canShowCityBody =
      hasDtoRanges ||
      (quarterlyCityTable && quarterlyCityTable.dashBoardDetailsWithPriceRange);

    if (useCity) {
      return (
        <div className="ye2-second-left">
          <div className={layoutClassName}>
            <img
              className="dashboard-iris-img"
              src={dashboardIrisImg}
              alt="March BG"
            />
            {(quarterlyCityTable || hasDtoRanges) && (
              <DashboardHeader
                MQCityDetails={quarterlyAreaTable}
                printVersion={printVersion}
                currentArea={currentArea}
                useCity={useCity}
                dashBoardMonths={dashBoardMonths}
                agentData={agentData}
                hoData={hoData}
                showEditButtons={showEditButtons}
                priceRangeDashBoardDetailsDTO={priceRangeDashBoardDetailsDTO}
                dashboardPriceRangeTitle={
                  priceRangeDashBoardDetailsDTO?.dashboardPriceRangeTitle
                }
                dashboardPriceRangeSubTitle={
                  priceRangeDashBoardDetailsDTO?.dashboardPriceRangeSubTitle
                }
              />
            )}
            {canShowCityBody && (
              <DashboardBody
                MQCityDetails={quarterlyCityTable}
                printVersion={printVersion}
                agentData={agentData}
                currentArea={currentArea}
                showEditButtons={showEditButtons}
                useCity={useCity}
                useTwoSectionLayout={useTwoSectionLayout}
                priceRangeDashBoardDetailsDTO={priceRangeDashBoardDetailsDTO}
              />
            )}

            <CallToActionPhone agentData={agentData} />

            <QVFourEmailAndWebsiteFooter
              agentData={agentData}
              currentArea={currentArea}
              printVersion={printVersion}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="ye2-second-left">
          <div className={layoutClassName}>
            <img
              className="dashboard-iris-img"
              src={dashboardIrisImg}
              alt="March BG"
            />
            {(quarterlyAreaTable || hasDtoRanges) && (
              <DashboardHeader
                MQCityDetails={quarterlyAreaTable}
                dashBoardMonths={dashBoardMonths}
                printVersion={printVersion}
                currentArea={currentArea}
                agentData={agentData}
                hoData={hoData}
                showEditButtons={showEditButtons}
                priceRangeDashBoardDetailsDTO={priceRangeDashBoardDetailsDTO}
                dashboardPriceRangeTitle={
                  priceRangeDashBoardDetailsDTO?.dashboardPriceRangeTitle
                }
                dashboardPriceRangeSubTitle={
                  priceRangeDashBoardDetailsDTO?.dashboardPriceRangeSubTitle
                }
              />
            )}
            {canShowAreaBody && (
              <DashboardBody
                MQCityDetails={quarterlyAreaTable}
                printVersion={printVersion}
                agentData={agentData}
                currentArea={currentArea}
                showEditButtons={showEditButtons}
                useCity={useCity}
                useTwoSectionLayout={useTwoSectionLayout}
                priceRangeDashBoardDetailsDTO={priceRangeDashBoardDetailsDTO}
              />
            )}

            <CallToActionPhone agentData={agentData} />

            {/*< <DashboardQRCode
              hoData={hoData}
              agentData={agentData}
              currentArea={currentArea}
              printVersion={printVersion}
            /> */}

            <QVFourEmailAndWebsiteFooter
              agentData={agentData}
              currentArea={currentArea}
              printVersion={printVersion}
            />
          </div>
        </div>
      );
    }
  }
}

export default PropAttributes;
